// @TODO remove the whole file after testing indexed db implementation
// commented bacauset the loader is not hiding since members store is empty
/* eslint-disable @typescript-eslint/no-unused-vars */ import { fromPairs, intersection, keyBy } from 'lodash';
import { MembershipsStore } from 'stores/memberships';
import { memoForCallbacks } from 'utils/memoForCallbacks';
export const constructUserMeta = memoForCallbacks(({ membershipsStore, active_user_ids, projectIds, users_list, currentUser, non_external_user_ids })=>{
    const getTupleById = (projectId)=>{
        var _ref;
        var _memberships_;
        const [_, _projectId] = projectId;
        const memberships = MembershipsStore.ofProject(projectId)(membershipsStore);
        const project_member_ids = (_ref = (_memberships_ = memberships[1]) === null || _memberships_ === void 0 ? void 0 : _memberships_.users) !== null && _ref !== void 0 ? _ref : [];
        const project_users = {
            private: {
                in_project_user_ids: intersection(project_member_ids, active_user_ids),
                not_in_project_user_ids: []
            },
            shared: {
                in_project_user_ids: intersection(project_member_ids, active_user_ids),
                not_in_project_user_ids: []
            }
        };
        return [
            projectId[1],
            project_users,
            active_user_ids
        ];
    };
    const tuples = projectIds.map(getTupleById);
    const by_user_id = keyBy(users_list, 'userId');
    const active_users_ids_from_all_projects = tuples.reduce((all_active, [, , shared_active])=>{
        all_active.push(...shared_active);
        return all_active;
    }, []);
    const unique_active_users_ids_from_all_projects = [
        ...new Set(active_users_ids_from_all_projects)
    ];
    const users = {
        active_user_ids: unique_active_users_ids_from_all_projects,
        non_external_user_ids,
        by_user_id,
        by_project_id: fromPairs(tuples)
    };
    return users;
}, (old, cur)=>{
    var _old_projectIds, _cur_projectIds, _old_active_user_ids, _cur_active_user_ids, _old_native_user_ids, _cur_native_user_ids, _old_current_company_active_user_ids, _cur_current_company_active_user_ids, _old_current_company_user_ids, _cur_current_company_user_ids;
    if (!old) {
        return false;
    }
    if (!cur) {
        return false;
    }
    let areEqual = true;
    // note to future refactors.
    // Here if conditions can't be swapped because all user count change is directly related to active user count. SO swapping condition would likely to show an stale data
    if (((_old_projectIds = old.projectIds) === null || _old_projectIds === void 0 ? void 0 : _old_projectIds.length) !== ((_cur_projectIds = cur.projectIds) === null || _cur_projectIds === void 0 ? void 0 : _cur_projectIds.length)) {
        areEqual = false;
    }
    if (((_old_active_user_ids = old.active_user_ids) === null || _old_active_user_ids === void 0 ? void 0 : _old_active_user_ids.length) !== ((_cur_active_user_ids = cur.active_user_ids) === null || _cur_active_user_ids === void 0 ? void 0 : _cur_active_user_ids.length)) {
        areEqual = false;
    }
    if (((_old_native_user_ids = old.native_user_ids) === null || _old_native_user_ids === void 0 ? void 0 : _old_native_user_ids.length) !== ((_cur_native_user_ids = cur.native_user_ids) === null || _cur_native_user_ids === void 0 ? void 0 : _cur_native_user_ids.length)) {
        areEqual = false;
    }
    if (((_old_current_company_active_user_ids = old.current_company_active_user_ids) === null || _old_current_company_active_user_ids === void 0 ? void 0 : _old_current_company_active_user_ids.length) !== ((_cur_current_company_active_user_ids = cur.current_company_active_user_ids) === null || _cur_current_company_active_user_ids === void 0 ? void 0 : _cur_current_company_active_user_ids.length)) {
        areEqual = false;
    }
    if (((_old_current_company_user_ids = old.current_company_user_ids) === null || _old_current_company_user_ids === void 0 ? void 0 : _old_current_company_user_ids.length) !== ((_cur_current_company_user_ids = cur.current_company_user_ids) === null || _cur_current_company_user_ids === void 0 ? void 0 : _cur_current_company_user_ids.length)) {
        areEqual = false;
    }
    if (old.membershipsStore !== cur.membershipsStore) {
        areEqual = false;
    }
    if (old.usersStore !== cur.usersStore) {
        areEqual = false;
    }
    if (areEqual) {
        return true;
    }
    return false;
});
